"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = void 0;
var initialState = exports.initialState = {
  unlocked: false,
  voices: {
    symbolLow: [[], [], [], [], [], [], [], [], [], [], []]
  },
  debug: false,
  soundStates: {}
};
//# sourceMappingURL=reducer.js.map